<main class="container-fluid px-0 pb-3 pb-lg-5">

  <div class="px-3 py-3 bg-darkest">
    <div class="container-lg">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="h3 fw-bold mb-0">{{provider ? provider.name : chosenProvider}} {{ chosenProvider?.includes('tom-horn') ? '' : 'CATEGORIES.TITLE' | translate }}</h1>
        <div class="provider-icon-overlay">
          <img *ngIf="provider" [src]="provider.imagePath" alt="provider background image" width="100%" (error)="updateNotFoundImgUrl($event)">
        </div>
      </div>
    </div>
  </div>


  <div class="container-lg" >
    <div class="px-0">
      <!-- Searchbar -->
      <app-searchbar [searchTerm]="searchTerm" (searchChange)="onSearchChange($event)"></app-searchbar>

      <section id="category-nav" class="my-4" >

        <div class="overflow-auto" id="pills-tab" *ngIf="activeCategories.length">
          <ul class="nav nav-pills bg-darkest rounded-pill flex-nowrap" role="tablist">
            <li class="nav-item" role="presentation" *ngFor="let category of activeCategories; let i = index">
              <button #tab class="nav-link rounded-pill d-flex flex-row text-nowrap py-2 ms-1" [class.active]="i == 0" [ngClass]="{'ms-1': i !== 0}"
                      [id]="'pills-'+ category +'-tab'" data-bs-toggle="pill"
                      [attr.data-bs-target]="'#pills-'+ category" type="button"
                      role="tab" aria-controls="pills-home" aria-selected="false" (click)="loadItems(undefined)" >
                <app-svg-icon class="variable-svg-icon me-2" [pathIdentifier]="category"></app-svg-icon>
                <span>{{"CATEGORIES." + (category.replace('-','') | uppercase) | translate}}</span>
              </button>
            </li>
          </ul>
        </div>

        <!-- backlink + sort by section-->
        <div class="d-flex justify-content-between my-4">
          <div>
            <a class="btn btn-outline-secondary rounded-pill d-flex align-items-center" routerLink="/providers">{{'PROVIDERS.PROV_LINK_LABEL' | translate}}</a>
          </div>

          <!-- sort by -->
          <div class="d-flex align-items-center justify-content-end me-1 sort-by-dropdown">
            <span class="d-none d-sm-block mx-2 text-secondary">{{ 'HOME.SORT_LABEL' | translate }}</span>
            <div class="btn-group">
              <button type="button" class="btn btn-outline-secondary rounded-pill d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="me-2">{{ 'HOME.SORT_'+ selectedSorting | translate }}</span>
                <app-svg-icon class="variable-svg-icon" [pathIdentifier]="'sort'"></app-svg-icon>
              </button>
              <ul class="dropdown-menu">
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('AZ')">{{ 'HOME.SORT_AZ' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('ZA')">{{ 'HOME.SORT_ZA' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('POPULAR')">{{ 'HOME.SORT_POPULAR' | translate }}</button></li>
                <li><button class="dropdown-item" type="button" (click)="sortOptionSelected('FEATURED')">{{ 'HOME.SORT_FEATURED' | translate }}</button></li>
              </ul>
            </div>
          </div>

       </div>

        <!-- games-->
        <div *ngIf="games && games.length else noGamesBlock " class="tab-content" id="pills-tabContent">
          <ng-container *ngFor="let category of activeCategories; let i = index">
            <div class="tab-pane fade show" [class.active]="i == 0"
                 [id]="'pills-' + category" role="tabpanel"
                 [attr.aria-labelledby]="'pills-' + category + '-tab'" tabindex="0">
              <div *ngIf="filteredGamesByCategory[i] && filteredGamesByCategory[i].length; else noGamesBlock">
                <app-game-chunk [games]="displayedGamesByCategory[i]"></app-game-chunk>

                <!-- Load more or less games-->
                <app-item-showcase [totalItems]="filteredGamesByCategory[i].length" [itemsPerPage]="itemsPerPage" [resetFlag]="resetBySortOrFilterNeeded" (itemsToLoad)="loadItems($event)" ></app-item-showcase>
              </div>
            </div>
          </ng-container>
        </div>

      </section>
    </div>

    <div class="mt-4">
      <app-providers-carousel ></app-providers-carousel>
    </div>

  </div>

</main>

<ng-template #noGamesBlock>
  <div class="container-lg text-center pt-5">
    <h3 >{{'HOME.NOMATCH_MESSAGE' | translate}}</h3>
    <h4 *ngIf="searchTerm">{{'HOME.NOMATCH_TIP' | translate}}</h4>
  </div>
</ng-template>



